// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27X_F","footer":"styles_footer__34lQM"};